import { Injectable } from '@angular/core';

@Injectable()
export class FeatureCheckerService {

    get(featureName: string): solid.features.IFeature {
        return solid.features.get(featureName);
    }

    getValue(featureName: string): string {
        return solid.features.getValue(featureName);
    }

    isEnabled(featureName: string): boolean {
        return solid.features.isEnabled(featureName);
    }

}